import request from "@/utils/request";

// 待考试列表
export function findPendingExam(data) {
  return request({
    url: `/api/student/exam/findPendingExam`,
    method: 'post',
    data
  })
}
// 待模拟考试列表
export function findPendingExamM(data) {
  return request({
    url: `/api/student/exam/findMockExamList`,
    method: 'post',
    data
  })
}

// 已考试列表
export function findEndExam(data) {
  return request({
    url: `/api/student/exam/findEndExam`,
    method: 'post',
    data
  })
}

// 待考试详情
export function findPendingExamById(data) {
  return request({
    url: `/api/student/exam/findPendingExamById`,
    method: 'post',
    data
  })
}

// 已考试详情
export function findEndExamById(data) {
  return request({
    url: `/api/student/exam/findEndExamById`,
    method: 'post',
    data
  })
}

// 开始考试
export function startExam(data) {
  return request({
    url: `/api/student/exam/startExam`,
    method: 'post',
    data
  })
}

// 提交试卷
export function submitPaper(data) {
  return request({
    url: `/api/student/exam/submitPaper`,
    method: 'post',
    data
  })
}

// 选择试卷
export function chooseExamPaper(data) {
  return request({
    url: `/api/student/exam/chooseExamPaper`,
    method: 'post',
    data
  })
}
// 模拟考试抽题
export function chooseExamPaperM(data) {
  return request({
    url: `/api/student/exam/chooseMockExamPaper`,
    method: 'post',
    data
  })
}